<template>
  <div class="page-container">
    <div class="container">
      <h1 class="title">{{ $t('footerMenu[2].childList[1].name') }}</h1>
      <div
          class="regulations-term"
          v-for="(item, index) in $t('popup.helpCenterList')"
          :key="index"
      >
        <div class="regulations-header" @click="toggleItem(index)">
          <h2 class="regulations-title">{{ item.title }}</h2>
          <i v-if="expandedIndex === index" class="el-icon-minus"></i>
          <i v-else class="el-icon-plus"></i>
        </div>
        <div class="regulations-content" v-show="expandedIndex === index">
          {{ item.content }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      expandedIndex: null
    };
  },
  methods: {
    toggleItem(index) {
      this.expandedIndex = this.expandedIndex === index ? null : index;
    }
  }
};
</script>

<style scoped lang="less">
.page-container {
  padding: 0.523rem 0.82rem;
  .container {
    min-height: 5rem;
    color: #0c0c0c;
  }
  .title {
    text-align: center;
    font-size: 0.85rem;
    font-weight: bold;
    margin: 0.5rem 0;
  }
  .regulations-term {
    margin-bottom: 1.3rem;
    .regulations-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      cursor: pointer;
    }
  }
  .regulations-title {
    font-size: 0.6615rem;
  }
  .toggle-icon {
    font-size: 1rem;
    font-weight: bold;
    transition: transform 0.3s ease;
  }
  .regulations-content {
    font-size: 0.63rem;
    line-height: 1.17rem;
    padding: 0.7rem 0;
  }
}
</style>
